module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui one column wide center aligned page padded grid",
    attrs: {
      "id": "attribution"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui horizontal divider"
  }, [_vm._v("Attribution")]), _c('p', [_vm._v("Text and Images: "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Main_Page"
    }
  }, [_vm._v("Wikipedia,  ")]), _vm._v("Trees: "), _c('a', {
    attrs: {
      "href": "http://tree.opentreeoflife.org/"
    }
  }, [_vm._v("Open Tree of Life")])]), _c('p', [_vm._v("Inspired by: "), _c('a', {
    attrs: {
      "href": "https://bl.ocks.org/mbostock/c034d66572fd6bd6815a"
    }
  }, [_vm._v("Tree of Life")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://coreytcallaghan.github.io/eBirder-visualizations/"
    }
  }, [_vm._v("Family Birding Visualizer")])]), _c('p', [_vm._v("Developed by: Original code was developed by John Wilshire and adapted for this project by Vaughn Shirey and Corey Callaghan")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e311ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Attribution.vue
// module id = 253
// module chunks = 1